import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './../layout';

import { updateablog, getExtBlogById  } from './../../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

import Slider from 'react-rangeslider'
import 'react-rangeslider/lib/index.css'

class Editblog extends Component {

  constructor(props) {
    super(props);
    this.state = {
      logged: localStorage.getItem("authentication"),
      auth_data: JSON.parse(localStorage.getItem("user_data")),
      category_data: [], collapse: 0, modalReply: false,
      current_comment: '', current_rid: 0, current_eid: '',
      PER_PAGE:15,
      total:0,
      loading:true,
      list:[],
      salary_range_forthisjob: 15000,
      organisation_place:'',
      organisation:'',
      job_role_other_disabled:true,
      job_subject_teaching_other_disabled:true,
      expected_qualification_other_disabled:true,
      examcertifications_other_disabled:true,
      skillsrequired_other_disabled:true
    }

    this.id =  this.props.match.params.id;
  
    this.handleChange = this.handleChange.bind(this);

  }
 

  componentDidMount() {

          var THIS = this;
  
          this.getExtBlog();   

  }


   
  getExtBlog(){

    let req = JSON.stringify({
        id:this.id
    })

    getExtBlogById(req).then(res => {
            if(res.status==1){
                let data=res.detail;
                this.setState({
                    blog_title: data.blog_title,
                    blog_url: data.blog_url,
                    blog_status: data.blog_status
                })
            }
    });
}

 

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
 
     
  };  
 
  handleSubmit =(e) =>{

 
    let req = JSON.stringify({
         
        blog_title: this.state.blog_title,
        blog_url : this.state.blog_url,
        blog_status : this.state.blog_status,
        blog_id : this.id
    })
    
    updateablog(req).then((response) => {
      
      if(response.status==1){
            
        NotificationManager.success('Updated successfully', 'Post an external article');

      }else{
            
        NotificationManager.error('Error', 'Post an external article');
      }

    });
}
  
 
  render() {
 
 
        return (
            <React.Fragment>
                <AdminLayout>
                    
            <div class="col-12 grid-margin">
            
              <div class="card">
                    <div class="card-body">

                     
                  <h4 class="card-title">External Blog - Add</h4>
                 
                  <div class="postajobform wc">

                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Blog Title </label>
                        <input type="text" class="form-control forminputcls" id="blog_title" name="blog_title" value={this.state.blog_title}  onChange={this.handleChange}/>
                        </div> 


                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Blog External URL </label>
                        <input type="text" class="form-control forminputcls" id="blog_url" name="blog_url" value={this.state.blog_url}  onChange={this.handleChange}/>
                        </div> 


                        <div class="formgroup end_date_option" id="end_date_option">
                        <label for="exampleInputPassword1">Status</label>
                        <select name="blog_status" class="formselectinputcls" value={this.state.blog_status} onChange={this.handleChange}> 
                                    <option value="">Select</option>
                                    <option value="1">Active</option>
                                    <option value="0">InActive</option>
                        </select>
                        </div> 

                        <div class="formgroup text-center paddingtop20">
                            <button type="button" name="postablog" class="btn btn-primary" onClick={this.handleSubmit}>Submit</button>
                        </div> 

                    </div>


                   </div>
              </div>

            </div> 
            
            <NotificationContainer/>


                </AdminLayout>
            </React.Fragment>
        )
    }

}

export default Editblog;


// WEBPACK FOOTER //
// ./src/components/bewise/wiseconnect/editblog.jsx